// extracted by mini-css-extract-plugin
export default {"inboxNavLinks":"InboxNavLinks_inboxNavLinks__D-IwI","active":"InboxNavLinks_active__eOCEJ"};